var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPaymentMethodMaestro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.402 10.9473C13.402 13.5596 11.3086 15.6773 8.72626 15.6773C6.14393 15.6773 4.05054 13.5596 4.05054 10.9473C4.05054 8.33498 6.14393 6.21729 8.72626 6.21729C11.3086 6.21729 13.402 8.33498 13.402 10.9473Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4679 10.9473C19.4679 13.5596 17.3745 15.6773 14.7922 15.6773C12.2098 15.6773 10.1165 13.5596 10.1165 10.9473C10.1165 8.33498 12.2098 6.21729 14.7922 6.21729C17.3745 6.21729 19.4679 8.33498 19.4679 10.9473Z",
    fill: "#0099DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7592 14.5473C12.7646 13.6797 13.402 12.3888 13.402 10.9472C13.402 9.50567 12.7646 8.21474 11.7592 7.34717C10.7539 8.21474 10.1165 9.50567 10.1165 10.9472C10.1165 12.3888 10.7539 13.6797 11.7592 14.5473Z",
    fill: "#6C6BBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodMaestro);
export default __webpack_public_path__ + "static/media/icon_payment_method_maestro.37b0ec923c07370ebfce43abe07cb3f8.svg";
export { ForwardRef as ReactComponent };